/**
 * APP: Taako.
 *
 * Constants for the App.
 * Animations and body copy
 *
 */

// Vars
const dimensions = { w: window.innerWidth, h: window.innerHeight, sah: window.innerHeight - 200 }

// APP level
const isProduction = true;

// DATA MODEL
const layerDataModel = {
  // Intro
  intro: {
    firstScreenDelay: 2000,
  },
  // Background Layer
  mainBackgroundCloudAlpha: 0.2,
  // Clouds
  clouds: [
    { // cloud 1
      useTexture: 0,
      position: {sx: 0, sy: dimensions.sah - 120 },
      speed: 0.3,
      alpha: 0.2,
      scale: [5, 5]
    },
    { // cloud 2
      useTexture: 2,
      position: {sx: 0, sy: dimensions.sah - 450},
      speed: 0.4,
      alpha: 0.3,
      scale: [5, 5]
    },
    {  // cloud 3
      useTexture: 1,
      position: {sx: 0, sy: dimensions.sah - 500},
      speed: 0.5,
      alpha: 0.6,
      scale: [5, 5]
    },
    {  // cloud 4
      useTexture: 1,
      position: {sx: 0, sy: dimensions.sah - 500},
      speed: 0.25,
      alpha: 0.5,
      scale: [5, 5]
    },
    {  // cloud 5
      useTexture: 2,
      position: {sx: 0, sy: dimensions.sah - 200 },
      speed: 0.5,
      alpha: 0.4,
      scale: [5, 5]
    }
  ],
  // Grass
  grass: {
    layer_1: {
      spriteHeight: 256,
      offsetY: 0,
      alpha: 1,
      blur: 0,
    },
    layer_2: {
      spriteHeight: 256,
      offsetY: -100,
      alpha: 1,
      blur: 2,
    }
  },
  // Vignette
  vignette: {
    alpha: 0.6,
  },
  // Rock
  rock: {
    startX:window.innerWidth/2,
    startY:window.innerHeight/3,
    speed:0.15,
    alpha:1,
    scale:[0.5,0.5],
    anchor:[0.5,0.5],
    blurAmount:0.01,
    rock_1_texture:''
  },
  // LightBurst
  lightBurst: {
    scale:[4,4],
    anchor:[0.5,0.5],
    alpha: 0.13,
    speed: 0.02, // for pulse of light layer when activated
  }
}

// APP copy
const layerCopyDeck = {
  intro: {
    firstScreenHeader: "Let’s make some magic.",
    firstScreenHeaderLine2: "(Turn your speakers on.)"
  }
}

// Codes
const validationCodeObj = [
  { c:'5_11_4_7_5_3_',  v:'', r:false, a1:'5_11_4_7_5_3', a2:'' },
  { c:'7_5_9_1_9_7_5_', v:'', r:false, a1:'7_5_9_1_9_7_5', a2:'' },
  { c:'10_4_4_3_9_6_7_', v:'', r:false, a1:'10_4_4_3_9_6_7', a2:'' },
  { c:'5_3_3_9_4_2_6_11_7_6_9_6_', v:'', r:false, a1:'5_3_3_9_4_2_6_11_7_6_9_6', a2:'' },
  { c:'5_11_4_3_9_6_7_6_1_10_6_3_11_10_', v:'', r:false, a1:'5_11_4_3_9_6_7_6_1_10_6_3_11_10', a2:'' },
  { c:'11_5_3_4_6_9_6_7_10_1_3_6_10_11_', v:'', r:false, a1:'5_11_4_3_9_6_7_6_1_10_6_3_11_10', a2:'' },
  { c:'4_3_7_5_6_6_4_10_2_', v:'', r:false, a1:'4_3_7_5_6_6_4_10_2', a2:'' },
  { c:'7_9_4_2_6_3_6_2_', v:'', r:false, a1:'7_9_4_2_6_3_6_2', a2:'' },
  { c:'7_4_8_2_6_5_1_2_', v:'', r:false, a1:'7_4_8_2_6_5_1_2', a2:'' },
  { c:'4_9_3_2_3_11_8_6_', v:'', r:false, a1:'4_9_3_2_3_11_8_6', a2:'' },
  { c:'7_9_3_8_5_11_6_2_', v:'', r:false, a1:'7_9_3_8_5_11_6_2', a2:'' },
  { c:'9_5_7_10_6_4_5_4_6_1_8_2_', v:'', r:false, a1:'9_5_7_10_6_4_5_4_6_1_8_2', a2:'' },
  { c:'5_10_2_10_3_5_5_4_1_9_7_8_', v:'', r:false, a1:'5_10_2_10_3_5_5_4_1_9_7_8', a2:'' },
  { c:'11_4_3_7_6_4_3_10_6_2_9_2_', v:'', r:false, a1:'11_4_3_7_6_4_3_10_6_2_9_2', a2:'' },
  { c:'9_8_10_4_1_10_6_', v:'', r:true, a1:'9_8_10_4_1_10_6', a2:'9_8_10_4_1_10_6_2' },
  { c:'9_6_4_2_8_3_5_', v:'', r:false, a1:'9_6_4_2_8_3_5', a2:'' },
  { c:'2_10_3_5_6_1_5_3_11_11_1_10_', v:'', r:false, a1:'2_10_3_5_6_1_5_3_11_11_1_10', a2:'' },
  { c:'5_3_11_8_6_11_8_7_1_8_1_1_', v:'', r:false, a1:'5_3_11_8_6_11_8_7_1_8_1_1', a2:'' },
  { c:'4_10_3_8_5_11_8_1_', v:'', r:false, a1:'4_10_3_8_5_11_8_1', a2:'' },
  { c:'9_10_3_4_6_5_1_2_', v:'', r:false, a1:'9_10_3_4_6_5_1_2', a2:'' },
  { c:'4_9_4_2_6_11_8_1_', v:'', r:false, a1:'4_9_4_2_6_11_8_1', a2:'' },
  { c:'4_10_4_2_6_3_8_1_', v:'', r:false, a1:'4_10_4_2_6_3_8_1', a2:'' },
  { c:'9_10_3_4_5_3_8_2_', v:'', r:false, a1:'9_10_3_4_5_3_8_2', a2:'' },
  { c:'11_4_3_7_2_6_10_8_6_2_9_2_', v:'', r:false, a1:'11_4_3_7_2_6_10_8_6_2_9_2', a2:'' },
  { c:'5_11_2_7_3_2_10_7_9_2_9_11_', v:'', r:false, a1:'5_11_2_7_3_2_10_7_9_2_9_11', a2:'' },
  { c:'9_8_6_10_6_5_5_3_9_2_2_1_', v:'', r:false, a1:'9_8_6_10_6_5_5_3_9_2_2_1', a2:'' },
  { c:'9_4_3_4_2_6_10_8_6_2_2_1_', v:'', r:false, a1:'9_4_3_4_2_6_10_8_6_2_2_1', a2:'' },
  { c:'8_4_6_7_3_4_5_7_1_2_7_8_', v:'', r:false, a1:'8_4_6_7_3_4_5_7_1_2_7_8', a2:'' },
  { c:'5_10_6_2_3_6_7_4_1_1_8_11_', v:'', r:false, a1:'5_10_6_2_3_6_7_4_1_1_8_11', a2:'' },
  // Special random from array
  { c:'6_7_10_7_2_2_7_', v:'', r:true, a1:'', a2:[
      '6_7_10_7_2_2_7',
      'cooktip2',
      'cooktip3',
      'cooktip4',
      'cooktip5',
      'cooktip6',
      'cooktip7',
      'cooktip8',
      'cooktip9',
      'cooktip10',
      'cooktip11',
      'cooktip12',
    ] },
]

const UIAudio = {
  btnClicksOk:[
    {name:'btn_1', fileName:"button1" },
    {name:'btn_2', fileName:"button2" },
    {name:'btn_3', fileName:"button3" },
    {name:'btn_4', fileName:"button4" },
    {name:'btn_5', fileName:"button5" },
    {name:'btn_6', fileName:"button6" },
    {name:'btn_7', fileName:"button7" },
    {name:'btn_8', fileName:"button8" },
    {name:'btn_9', fileName:"button9" },
    {name:'btn_10', fileName:"button10" },
    {name:'btn_11', fileName:"button11" },
    {name:'btn_12', fileName:"cancel" },
    {name:'btn_send_success', fileName:"send-success" },
    {name:'btn_send_fail', fileName:"send-fail" },
  ],
  // not used yet. ?
  btnClicksErrors: [
  ],
  // sfx ? ( not sure as no scrip to lay out 'times' when these woudl be played
  sfx: [

  ]
}

// EXPORT
module.exports = Object.freeze({

  IS_PRODUCTION: isProduction,
  LAYER_DATA: layerDataModel,
  LAYER_COPY: layerCopyDeck,
  CODE_OBJ: validationCodeObj,
  UI_AUDIO: UIAudio
})



// WEBPACK FOOTER //
// ./src/Constants/index.js